import { CalendarCheck, Mail, MapPin, Phone } from "lucide-react";
import { EMAIL, PHONE_DISPLAY, PHONE_TEL } from "../../lib/constants";
import mailIcon from "../../assets/mail.png";
import { HOME_WRAP } from "./HomeShared";
import { useAppointment } from "../../context/AppointmentContext";

export default function ContactSection() {
  const { openAppointment } = useAppointment();

  return (
    <section className={`${HOME_WRAP} pb-16`}>
      <div className="grid min-w-0 gap-5 lg:grid-cols-3 xl:gap-8">
<a href={`tel:${PHONE_TEL}`} className="self-start flex flex-col min-w-0 gap-3 rounded-[14px] bg-[#064d7c] px-4 py-4 text-white sm:gap-6 sm:px-6 sm:py-6 xl:gap-7 xl:px-5">
  <div className="flex min-w-0 items-center gap-3 sm:gap-6 xl:gap-4">
    <Phone className="h-9 w-9 shrink-0 stroke-[1.8] sm:h-14 sm:w-14" />
    <h3 className="break-words text-[15px] font-bold leading-tight min-[390px]:text-[17px] sm:text-[19px] lg:text-[18px] xl:text-[20px] 2xl:text-[18px]">{PHONE_DISPLAY}</h3>
  </div>
  <p className="max-w-[380px] text-[14px] leading-snug sm:text-[19px] lg:text-[21px]">Contact us for appointments and consultations</p>
</a>
<a href={`mailto:${EMAIL}`} className="self-start flex flex-col min-w-0 gap-3 rounded-[14px] bg-[#72b7dc] px-4 py-4 text-[#071746] sm:gap-6 sm:px-6 sm:py-6 xl:gap-7 xl:px-5">
    <div className="flex min-w-0 items-center gap-3 sm:gap-6 xl:gap-4">
    <img src={mailIcon} alt="Mail" className="h-9 w-9 shrink-0 sm:h-14 sm:w-14 object-contain" />
    <h3 className="break-words text-[15px] font-bold leading-tight min-[390px]:text-[17px] sm:text-[19px] lg:text-[18px] xl:text-[20px] 2xl:text-[18px]">{EMAIL}</h3>
  </div>
  <p className="max-w-[410px] text-[14px] leading-snug sm:text-[19px] lg:text-[21px]">Reach out for inquiries, appointments, or support</p>
</a>
<article className="self-start flex flex-col min-w-0 gap-3 rounded-[14px] border-2 border-[#071746] bg-white px-4 py-4 text-black sm:gap-6 sm:px-6 sm:py-6 xl:gap-7 xl:px-5">
  <div className="flex min-w-0 items-center gap-3 sm:gap-6 xl:gap-4">
    <MapPin className="h-9 w-9 shrink-0 stroke-[1.8] sm:h-14 sm:w-14" />
    <h3 className="break-words text-[15px] font-bold leading-tight min-[390px]:text-[17px] sm:text-[19px] lg:text-[18px] xl:text-[20px] 2xl:text-[18px]">Jamaica</h3>
  </div>
  <p className="max-w-[390px] text-[14px] leading-snug sm:text-[19px] lg:text-[21px]">Experience exceptional dental care in a welcoming environment</p>
  {/* <button
    type="button"
    onClick={openAppointment}
    className="inline-flex items-center gap-2 text-[15px] font-bold text-[#0052ff] transition hover:text-[#003ec2]"
  >
    <CalendarCheck className="h-4 w-4" />
    Book before you visit
  </button> */}
</article>
      </div>
      <div className="mt-8 overflow-hidden rounded-[16px] border-2 border-[#064d7c]">
        <iframe
          title="Be Dental Paradise map"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7962.42591590616!2d-77.50708002234194!3d18.04221503334419!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8edbbf42dc065ebb%3A0x96853e805de56674!2sBe%20Dental%20Paradise!5e0!3m2!1sen!2sin!4v1781177788413!5m2!1sen!2sin"
          className="aspect-[1660/400] min-h-[270px] w-full md:min-h-0"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </section>
  );
}
